export default __webpack_public_path__ + "e5453820215633ef4fbf7ef7f563060f.png";